import axios from "axios";
import { headersProvider } from "../pages/utilities";

export const getAttacchedFiles = async ({ id }) => {
  return axios
    .get(`${process.env.REACT_APP_API_URL}/attachedfiles/${id}`, {
      headers: headersProvider(),
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("There was an error logging in!", error);
      throw error;
    });
};

export const attachFiles = async ({ body }) => {
  return axios
    .post(
      `${process.env.REACT_APP_API_URL}/attachfiles`,
      { ...body },
      {
        headers: headersProvider(),
      }
    )
    .then((response) => response.data)
    .catch((error) => {
      console.error("There was an error attaching file", error);
      throw error;
    });
};

export const updateFileTranId = async ({ body }) => {
  return axios
    .put(
      `${process.env.REACT_APP_API_URL}/updateTranIdForFiles`,
      { ...body },
      {
        headers: headersProvider(),
      }
    )
    .then((response) => response.data)
    .catch((error) => {
      console.error("There was an error attaching tran to file", error);
      throw error;
    });
};

export const getFilesForTran = async ({ id }) => {
  return axios
    .post(
      `${process.env.REACT_APP_API_URL}/getfilesfortran`,
      { id },
      {
        headers: headersProvider(),
      }
    )
    .then((response) => response.data)
    .catch((error) => {
      console.error("There was an error getting file for tran", error);
      throw error;
    });
};

export const getFile = async ({ id }) => {
  return axios
    .post(
      `${process.env.REACT_APP_API_URL}/getfile`,
      { id },
      {
        headers: headersProvider(),
      }
    )
    .then((response) => response.data)
    .catch((error) => {
      console.error("There was an error getting file", error);
      throw error;
    });
};

export const attachFileToParent = async ({ fileName, parent, parentId }) => {
  return axios
    .post(
      `${process.env.REACT_APP_API_URL}/attach-file-to-parent`,
      { fileName, parent, parentId },
      {
        headers: headersProvider(),
      }
    )
    .then((response) => response.data)
    .catch((error) => {
      console.error("There was an error attaching file", error);
      throw error;
    });
};

export const getReadUrl = async ({ hostedLink }) => {
  return axios
    .post(
      `${process.env.REACT_APP_API_URL}/getreadurl`,
      { hostedLink },
      {
        headers: headersProvider(),
      }
    )
    .then((response) => response.data)
    .catch((error) => {
      console.error("There was an error getting read url", error);
      throw error;
    });
};

export const deleteFile = async ({ id }) => {
  return axios
    .post(
      `${process.env.REACT_APP_API_URL}/deleteFile`,
      { id },
      {
        headers: headersProvider(),
      }
    )
    .then((response) => response.data)
    .catch((error) => {
      console.log("there was an errror deleting file ", error);
    });
};
